"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var LogOut = function LogOut(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M83.05 45l-8.11-8.11a2 2 0 0 1 0-2.83l2.12-2.12a2 2 0 0 1 2.83 0l14.646 14.646a2 2 0 0 1 0 2.828L79.889 64.061a2 2 0 0 1-2.828 0l-2.122-2.122a2 2 0 0 1 0-2.828L82.05 52H30a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h53.05zM68 25h-7V9a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v78a2 2 0 0 0 2 2h50a2 2 0 0 0 2-2V71h7v23a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h64a2 2 0 0 1 2 2v23z",
    fill: "currentColor"
  })));
};
var _default = exports.default = LogOut;